import DealDislikeSignalModal from './DealDislikeSignalModal.component';

export default DealDislikeSignalModal;
